/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IGetPayPeriodsResponse } from '../../../types';
import { IPayPeriodsState } from '../../types';
import { PayPeriods } from './types';

const initialState: IPayPeriodsState | null = null;

export const payPeriodsReducer: Reducer<IPayPeriodsState | null> = (state = initialState, action) => {
  switch (action.type) {
    case PayPeriods.GET_PAY_PERIODS_SUCCESS: {
      const { siteId, orgId, response } = action.payload;

      return {
        ...state?.payPeriods,
        [orgId]: {
          ...state?.payPeriods?.[orgId],
          [siteId]: response as IGetPayPeriodsResponse,
        },
      };
    }
    default: {
      return state;
    }
  }
};
